import { useHall } from '@/contexts/HallProvider'
import { useAblyTypedPubSub } from '../use-ably'

export const useJudgementPubSub = ({
  judgment,
  setJudgment,
}: {
  judgment: string
  setJudgment: (val: string) => void
}) => {
  const { hall } = useHall()

  const { publish } = useAblyTypedPubSub<string>('judgment', ({ data }) => {
    if (data === '__RESET__' || data === null) {
      setJudgment('')
    } else {
      setJudgment(data)
    }
  })

  const publishJudgement = (judgment: string) => {
    publish(judgment)
  }

  return {
    publishJudgement,
    judgment,
  }
}
